const SHADER_MAP = {};

export default SHADER_MAP;
